import React from 'react';

const NewProgressBar = ({ percent }) => {
  return (
    <div className="relative h-2 rounded-full bg-gray-300">
      <div className="absolute h-2 rounded-full bg-purple-600" style={{ left: 0, right: `${100 - percent}%` }}></div>
    </div>
  );
};

export default NewProgressBar;